var $a877df8ebbcdc5f7$exports = {};
$a877df8ebbcdc5f7$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Vybrat\xfd d\xe1tum`,
            other: `Vybrat\xe9 d\xe1tumy`
        })}: nedostupn\xe9.`
};


export {$a877df8ebbcdc5f7$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
